const isLaptop = window.matchMedia("(max-width: 1520px)").matches;
export default isLaptop;
